/**
 * DASHBOARD-HEATMAP-SKELETON.WIDGET
 * Skeleton adapté à la matrice (dashboard-heatmap.widget.tsx) : les deux menus (population, lignes), les
 * en-têtes de colonnes inclinées, la recherche, puis des lignes à libellé sur deux lignes et de petites pastilles
 * alignées à gauche comme les vraies cellules (colonnes de 50 px). Un reflet balaie l'ensemble.
 */
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const ROW_COUNT = 12
const COL_COUNT = 10
const LABEL_WIDTH = 400
const COLUMN_WIDTH = 50

export default function DashboardHeatmapSkeletonWidget() {
  return (
    <div
      className="rel"
      style={{
        padding: "20px 40px 20px 32px",
        overflow: "hidden",
        width: "100%",
        minHeight: "75vh",
        boxSizing: "border-box"
      }}>
      {/* Menus : lignes à gauche, populations au-dessus des colonnes */}
      <div className="flex" style={{ alignItems: "flex-end", height: 100 }}>
        <div style={{ width: LABEL_WIDTH, flexShrink: 0 }}>
          <Skeleton width={110} height={32} borderRadius={16} />
        </div>
        <div className="rel" style={{ flex: 1, height: "100%" }}>
          <Skeleton width={96} height={32} borderRadius={16} style={{ position: "absolute", top: 0, left: 0 }} />
          {/* Même technique que .heatmap-column-text : rotation ancrée en absolute dans une colonne de largeur
          fixe, pour que les pivots restent alignés sur une ligne droite */}
          <div className="flex" style={{ position: "absolute", bottom: 0, left: 0 }}>
            {Array.from({ length: COL_COUNT }).map((_, i) => (
              <div key={i} className="rel" style={{ width: COLUMN_WIDTH, height: 50 }}>
                <Skeleton
                  width={64}
                  height={11}
                  style={{
                    position: "absolute",
                    left: 18,
                    bottom: 0,
                    transform: "rotate(-45deg)",
                    transformOrigin: "bottom left"
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <Skeleton width={150} height={10} style={{ margin: "16px 0 22px" }} />

      {Array.from({ length: ROW_COUNT }).map((_, row) => (
        <div key={row} className="flex items-center" style={{ marginBottom: 14 }}>
          <div style={{ width: LABEL_WIDTH, flexShrink: 0, paddingRight: 24 }}>
            <Skeleton width={row % 3 === 0 ? 120 : 90} height={9} style={{ marginBottom: 7 }} />
            <Skeleton width={row % 2 === 0 ? "92%" : "70%"} height={13} />
          </div>
          {Array.from({ length: COL_COUNT }).map((_, col) => (
            <div key={col} className="flex" style={{ width: COLUMN_WIDTH, justifyContent: "center" }}>
              <Skeleton width={38} height={22} borderRadius={11} />
            </div>
          ))}
        </div>
      ))}

      <SkeletonShine />
    </div>
  )
}
